export default "__VITE_ASSET__OwvPbuq4__"